'use client'

import { useLivePreview } from '@payloadcms/live-preview-react'

import { HomePageContent } from './HomePageContent'
import { getClientSideURL } from '@/utilities/getURL'

type HomePageData = {
  blocks?: any[]
}

type Props = {
  initialHomePage: HomePageData
}

export const HomePagePreview = ({ initialHomePage }: Props) => {
  const { data } = useLivePreview<HomePageData>({
    depth: 3,
    initialData: initialHomePage,
    serverURL: getClientSideURL(),
  })

  if (!data) return null

  return <HomePageContent homePage={data} />
}
